import { render, staticRenderFns } from "./myOrder.vue?vue&type=template&id=7b5680c2&scoped=true"
import script from "./myOrder.vue?vue&type=script&lang=js"
export * from "./myOrder.vue?vue&type=script&lang=js"
import style0 from "./myOrder.vue?vue&type=style&index=0&id=7b5680c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5680c2",
  null
  
)

export default component.exports